/*
 * @Description: 数字品牌价值及三维度-柱状图
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-20 14:31:45
 * @LastEditTime: 2019-08-05 16:08:35
 */

import moment from 'moment';
import { toThousands } from '../utils';

export default (data, query, color = '#c2e1c5') => {

  const data1 = data.charts

  const axisLabel = (() => {
    const result = {};
    if (query.rotate) {
      result.rotate = 0
    }
    return result;
  })();

  let timeArr = []
  const len = data1.length

  for (let i = 0; i < data1.length; i++) {
    timeArr.unshift(moment(query.statisDate).subtract(i, 'days').format('MM.DD'))
  }
  let chartsJson = []

  for (let i in data1) {
    let barData =
    {

      name: 'DB总值',
      type: 'bar',
      value: data1[i],
      itemStyle: {
        normal: {
          color: color
        }
      },
      label: {
        normal: {
          show: timeArr.length <= 10,
          position: data1[i] >= 0 ? 'top' : 'bottom',
          color: '#000',
          fontWeight: 'bold'
        }
      },
    }
    chartsJson.push(barData)

  }

  return {
    title: {
      text: `${query.title ? query.title : `${query.platformName}平台单日DB值`} - ${query.brandName}`,
      subtext: `时间窗口：${moment(query.startDate).format('YYYY.MM.DD')} - ${moment(query.statisDate).format('YYYY.MM.DD')}`,
      // sublink:'',
      x: '20'
    },
    color: [
      '#c2e1c5', '#fac8a7', '#abd9f2', '#f1b1ad'
    ],
    legend: {
      show: false,
      data: [
        '微信', '微博', '知乎', '今日头条', 'DB总值'
      ],
      align: 'left'
    },
    toolbox: {
      right: 20,
      show: false,
      feature: {
        dataView: {
          show: true
        },
        restore: {
          show: true
        },
        saveAsImage: {
          show: true
        }
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    xAxis: {
      data: timeArr,
      type: 'category',
      silent: false,
      splitLine: {
        show: false
      },
      axisLabel
    },
    yAxis: [
      {
        type: 'value',
      }
    ],
    grid: {
      left: 100,
      top: 80,
      bottom: 30
    },
    series: [
      {
        name: 'DB总值',
        type: 'bar',
        itemStyle: {
          normal: {
            color: color
          }
        },
        barWidth: len > 7 ? '0' : '40',
        barMaxWidth: '40',
        label: {
          normal: {
            formatter: ({value}) => toThousands(value),
            show: timeArr.length <= 10,
            position: 'top',
            color: '#000',
            fontWeight: 'bold'
          }
        },
        data: chartsJson
      }
    ],
    animationEasing: 'elasticOut',
    animationDelayUpdate: function (idx) {
      return idx * 5;
    }
  }
};


// WEBPACK FOOTER //
// src/chart/brandValueBar.js